import { useMemo } from 'react';

import { TAdBannerPlaceParameters } from '../../AdBannerMicrofrontendContainer';

/**
 * Константы места баннера спецпроекта над выдачей.
 *
 * Должны совпадать с легаси-размещением Adfox (SpecialProjectBannerContainer): place —
 * аналитическое место, isSp — спецпроект, pParams различаются для коммерческой выдачи, sizes — размеры.
 */
const PLACE = 'above_offers';
const P_PARAMS: TAdBannerPlaceParameters['pParams'] = { p1: 'cwlpf', p2: 'hyhj' };
const P_PARAMS_COMMERCIAL: TAdBannerPlaceParameters['pParams'] = { p1: 'dmepr', p2: 'hyhj' };
const SIZES: TAdBannerPlaceParameters['sizes'] = { width: '100%', height: 174 };

interface IUseSpecialProjectParametersParams {
  isCommercial: boolean;
}

/**
 * Параметры места баннера спецпроекта над выдачей (desktop).
 */
export function useSpecialProjectParameters({
  isCommercial,
}: IUseSpecialProjectParametersParams): TAdBannerPlaceParameters {
  return useMemo(
    () => ({
      place: PLACE,
      pParams: isCommercial ? P_PARAMS_COMMERCIAL : P_PARAMS,
      sizes: SIZES,
      position: null,
      galleryPosition: null,
      isSp: true,
      tgbNativedescGeneralDesign: null,
      carousel: null,
      deviceType: 'desktop',
    }),
    [isCommercial],
  );
}
